/**
 * Configurações de timeout para o sistema de autenticação
 */
export const timeoutConfig = {
  // Timeout principal de logout automático (em milissegundos)
  AUTO_LOGOUT_TIMEOUT: 10 * 60 * 1000, // 10 minutos

  // Tempo de aviso prévio antes do logout (em milissegundos)
  WARNING_TIMEOUT: 2 * 60 * 1000, // 2 minutos antes

  // Duração do toast de aviso (em milissegundos)
  WARNING_TOAST_DURATION: 5000, // 5 segundos

  // Duração do toast de logout (em milissegundos)
  LOGOUT_TOAST_DURATION: 3000, // 3 segundos

  // Intervalo para verificar atividade (em milissegundos)
  ACTIVITY_CHECK_INTERVAL: 30 * 1000, // 30 segundos

  // Eventos que indicam atividade do usuário
  ACTIVITY_EVENTS: [
    'mousedown',
    'mousemove',
    'keypress',
    'keydown',
    'scroll',
    'touchstart',
    'touchmove',
    'click',
    'focus',
    'blur',
    'resize',
  ],

  // Configurações de debounce para eventos de mouse
  MOUSE_DEBOUNCE_DELAY: 1000, // 1 segundo

  // Configurações de debounce para eventos de teclado
  KEYBOARD_DEBOUNCE_DELAY: 500, // 500ms
};

export default timeoutConfig;
